import { MultiSelect, MultiSelectProps } from '@mantine/core';
import { forwardRef, useImperativeHandle, useRef } from 'react';

export type MultiSelectRef = {
  getSelectedValues: () => string[];
};

export const ForwardRefMultiSelect = forwardRef<MultiSelectRef, MultiSelectProps>((props, ref) => {
  const internalValueRef = useRef<string[]>([]);

  useImperativeHandle(ref, () => ({
    getSelectedValues: () => internalValueRef.current,
  }));

  return (
    <MultiSelect
      {...props}
      onChange={(val) => {
        internalValueRef.current = val;
        props.onChange?.(val);
      }}
    />
  );
});
